import React from 'react';
import Heart from '../../assets/heart.svg';

function RadioButton({title, checked, onChange}) {
    return (
        <div className={'radioButtonContainer'} onClick={onChange}>
            <button>
                {checked ? <img src={Heart} alt={'checking'}/> : null}
            </button>
            <p>
                {title}
            </p>
        </div>
    )
}

export default RadioButton;